import script from "./EventsGoods.vue?vue&type=script&setup=true&lang=js"
export * from "./EventsGoods.vue?vue&type=script&setup=true&lang=js"

import "./EventsGoods.vue?vue&type=style&index=0&id=37ad52ae&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37ad52ae"]])

export default __exports__